export default function (other) {
  other = other || {}
  return {
    id: other.id || null,
    firstName: other.firstName || null,
    lastName: other.lastName || null,
    phone: other.phone || null,
    country: other.country || null,
    language: other.language || null,
    email: other.email || null,

    orgId: other.orgId || null,
    online: other.online || null,
    deliveryDate: other.deliveryDate || null,
    statusUpdateTime: other.statusUpdateTime || null,
    isFtd: other.isFtd || null,

    trafficSource: other.trafficSource || null,
    subSource: other.subSource || null,
    clickId: other.clickId || null,
    page: other.page || null,
    description: other.description || null,
    brandStatus: other.brandStatus || null,
    campaign: other.campaign || null,
    brand: other.brand || null,

    lastNote: other.lastNote || null,
    ftdNote: other.ftdNote || null,

  }
}
